import { 
  IoLibrary, 
  IoHandLeftOutline, 
  IoStorefront, 
  IoStar, 
  IoPerson, 
  IoPeople, 
  IoHeart, 
  IoFlash 
} from 'react-icons/io5';

// Import subcategory images
import lugaresImg from '../../../assets/conectados/sabiduria/lugares-board.png';
import variedadesImg from '../../../assets/conectados/sabiduria/variedad-board.png';
import personajesImg from '../../../assets/conectados/sabiduria/personajes-board.png';
import arriesgamosImg from '../../../assets/conectados/alianza/arriesgamos-board.png';
import siNosotrosImg from '../../../assets/conectados/alianza/si-nosotros-board.png';
import coincidimosImg from '../../../assets/conectados/alianza/coincidimos-board.png';

export const categoryData = {
  sabiduria: {
    title: 'Sabiduría',
    titleIcon: IoLibrary,
    subcategories: [
      { 
        key: 'personajes', 
        title: 'Personajes', 
        titleIcon: IoPerson,
        description: 'Personajes y figuras bíblicas',
        image: personajesImg
      },
      { 
        key: 'lugares', 
        title: 'Lugares', 
        titleIcon: IoStorefront,
        description: 'Lugares y ubicaciones bíblicas',
        image: lugaresImg
      },
      { 
        key: 'variedades', 
        title: 'Variedades', 
        titleIcon: IoStar,
        description: 'Diferentes aspectos de la fe',
        image: variedadesImg
      },
    ]
  },
  alianza: {
    title: 'Alianza',
    titleIcon: IoHandLeftOutline,
    description: 'Explora el pacto, la unidad y la valentía',
    color: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    subcategories: [
      { 
        key: 'si-nosotros', 
        title: 'Si Nosotros', 
        titleIcon: IoPeople,
        description: 'Nuestro papel en el pacto de Dios',
        image: siNosotrosImg
      },
      { 
        key: 'coincidimos', 
        title: 'Coincidimos', 
        titleIcon: IoHeart,
        description: 'Encontrar puntos en común en la fe',
        image: coincidimosImg
      },
      { 
        key: 'arriesgamos', 
        title: 'Arriesgamos', 
        titleIcon: IoFlash,
        description: 'Tomar riesgos por nuestras creencias',
        image: arriesgamosImg
      }
    ]
  }
};

export const subcategoryData = {
  'sabiduria': {
    'lugares': { title: 'Lugares', titleIcon: IoStorefront, description: 'Lugares y ubicaciones bíblicas', color: '#4facfe' },
    'variedades': { title: 'Variedades', titleIcon: IoStar, description: 'Diferentes aspectos de la fe', color: '#4facfe' },
    'personajes': { title: 'Personajes', titleIcon: IoPerson, description: 'Personajes y figuras bíblicas', color: '#4facfe' }
  },
  'alianza': {
    'si-nosotros': { title: 'Si Nosotros', titleIcon: IoPeople, description: 'Nuestro papel en el pacto de Dios', color: '#43e97b' },
    'coincidimos': { title: 'Coincidimos', titleIcon: IoHeart, description: 'Encontrar puntos en común en la fe', color: '#43e97b' },
    'arriesgamos': { title: 'Arriesgamos', titleIcon: IoFlash, description: 'Tomar riesgos por nuestras creencias', color: '#43e97b' }
  }
}; 